import React from 'react';
import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { transportOrderState } from '../../Config/constants';
import { useTranslation } from 'react-i18next';

export default function TransportOrdersTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const rows = props.orders.map(order =>
        createData(order.id, order.momentInserted, order.momentstarted, order.product, order.from, order.arrow, order.to, order.state)
    )

    function createData(id, momentInserted, momentStarted, product, from, arrow, to, state) {

        let stateColor = "";
        let backgroundColor = "";
        let dateStarted = "";
        let timeStarted = "";
        let dateInserted = "";
        let timeInserted = "";

        switch (state) {
            case transportOrderState.done:
                stateColor = "#5CC958"
                backgroundColor = "#F4FFF4"
                break;
            case transportOrderState.stopped:
                stateColor = "#D84949"
                backgroundColor = "#D849490F"
                break;
            case transportOrderState.moving:
                stateColor = "#F59127"
                backgroundColor = "#FFF7EF"
                break;
            default:
                stateColor = "#5CC958"
                backgroundColor = "#F4FFF4"
                break;
        }

        let startArray = momentStarted.split(' ');
        dateStarted = startArray[0];
        timeStarted = startArray[1];

        let insertArray = momentInserted.split(' ');
        dateInserted = insertArray[0];
        timeInserted = insertArray[1];

        return { id, dateInserted, timeInserted, dateStarted, timeStarted, product, from, arrow, to, state, stateColor, backgroundColor };
    }

    return (
        <div>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headCell}>N°</TableCell>
                        <TableCell className={classes.headCell}>{t("Order registered")}</TableCell>
                        <TableCell className={classes.headCell}>{t("Order started")}</TableCell>
                        <TableCell className={classes.headCell}>{t("Product")}</TableCell>
                        <TableCell className={classes.headCell}>{t("From")}</TableCell>
                        <TableCell className={classes.headCell}></TableCell>
                        <TableCell className={classes.headCell}>{t("To")}</TableCell>
                        <TableCell className={classes.headCell}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody className={classes.tableBody}>
                    {rows.map((row) => (
                        <TableRow key={row.id} className={classes.row}>
                            <TableCell className={classes.infoCell} style={{ backgroundColor: row.backgroundColor, borderLeft: "1px solid #DEDEDE", borderRadius: "6px 0 0 6px" }}>{row.id}</TableCell>
                            <TableCell className={classes.infoCell} style={{ backgroundColor: row.backgroundColor }}>
                                <div className={classes.date}>{row.dateInserted}</div>
                                <div className={classes.time}>{row.timeInserted}</div>
                            </TableCell>
                            <TableCell className={classes.infoCell} style={{ backgroundColor: row.backgroundColor }}>                            
                                <div className={classes.date}>{row.dateStarted}</div>
                                <div className={classes.time}>{row.timeStarted}</div>
                            </TableCell>
                            <TableCell className={classes.infoCell} style={{ backgroundColor: row.backgroundColor }}>{row.product}</TableCell>
                            <TableCell className={classes.infoCell} style={{ backgroundColor: row.backgroundColor }}>{row.from}</TableCell>
                            <TableCell className={classes.arrowCell} style={{ backgroundColor: row.backgroundColor }}>{row.arrow}</TableCell>
                            <TableCell className={classes.infoCell} style={{ backgroundColor: row.backgroundColor }}>{row.to}</TableCell>
                            <TableCell className={classes.stateCell} style={{ color: row.stateColor, backgroundColor: row.backgroundColor, borderRight: "1px solid #DEDEDE", borderRadius: " 0 6px 6px 0" }} align="right">{row.state}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    )

}

const useStyles = makeStyles(() => ({

    table: {
        width: "100%",
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "10px",
        border: "none"
    },
    stateCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        paddingLeft: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE"
    },
    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        paddingLeft: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE"
    },
    arrowCell: {
        fontSize: "14px",
        fontFamily: "MS PGothic, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        paddingLeft: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE"
    },
    date: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
    },
    time: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        display: 'block'
    }
}));